export default __webpack_public_path__ + "static/media/Processing.a1dcffe7.png";